import { useMutation } from '@tanstack/react-query';
import { EInvoiceAccountsService } from 'services/openapi';

type RemoveEInvoiceAccountMutationVariables = {
  accountId: string;
};

export const useRemoveEInvoiceAccountMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, RemoveEInvoiceAccountMutationVariables>({
      mutationFn: (variables: RemoveEInvoiceAccountMutationVariables) => {
        return EInvoiceAccountsService.einvoiceAccountControllerDeleteHiloAccount(
          variables.accountId,
        );
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
